import { List, FormLabel } from '@material-ui/core';
import * as React from 'react';
import CheckboxListItem from './CheckboxListItem';

interface ICheckboxListProps {
  label: string;
  availableItems: string[];
  checkedItems: string[];
  onChange?: (checkedItems: string[]) => void;
  readOnly?: boolean;
  required?: boolean;
}

class CheckboxList extends React.Component<ICheckboxListProps> {
  public render(): JSX.Element {
    const { label, availableItems, required, readOnly, checkedItems } = this.props;

    return (
      <List style={{ padding: 0 }}>
        <FormLabel component="legend" required={required}>{label}</FormLabel>
        {availableItems.map((item) => {
          return (
            <CheckboxListItem
              readOnly={readOnly}
              isChecked={checkedItems.indexOf(item) > -1}
              onCheckItem={this.handleCheck}
              key={item}
              name={item}
            />
          );
        })
        }
      </List>
    );
  }

  private handleCheck = (name: string, isChecked: boolean) => {
    const { checkedItems, onChange } = this.props;

    const willBeChecked = !isChecked;
    const changedItems: string[] = willBeChecked ? checkedItems.concat(name) : checkedItems.filter((x) => x !== name);

    this.setState({
      checkedItems: changedItems
    }, () => {
      if (onChange) {
        onChange(changedItems);
      }
    });
  }
}

export default CheckboxList;
